import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.93 37.415c2.678-.106 11.198-.237 11.216.085.305 5.296 9.345 10.302 16.025 10.39 1.33.016 10.705-.015 10.705-.015v-9.188s-11.03.145-10.485-.13c.11-.057-7.515-.87-7.927-5.335-.057-.627-.49-1.235 0-2.444C39.5 25.75 45.25 25.25 45.25 25.25h10.813v-8.625s-.376-.313-11.063.097c-13.227.507-12.7 6.82-15.55 9.32-.83.73-8.93.675-11.45.568V20L6 32l11.875 11.563.055-6.148z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }